<template>
  <div class="login-container">
    <!-- 添加图标到左上角 -->
    <div class="nav">
      <div class="logo-container" @click="backHome">
        <img
          src="../../assets/mobile/122322.png"
          alt="Logo"
          class="logo-image"
        />
        <span style="font-size: 12px !important; white-space: nowrap"
          >運命シンカー</span
        >
      </div>

      <div
        class="time-container"
        style="
          font-family: Source Han Serif SC, Source Han Serif SC;
          font-size: 11px;
        "
      >
        <div class="time">{{ currentTime }}</div>
        <div class="lunar-date">{{ lunarDate }}</div>
      </div>
    </div>
    <div class="mask" v-show="currentStep === 'agreement'">
      <div class="mask-content">
        <div class="mask-pos" style=""></div>
        <div class="mask-title">
          <span class="icon">⚠️</span>
          <strong>本サービスは18歳以上を対象とした娯楽目的のAI占いです</strong>
        </div>
        <div class="mask-text">
          <p>
            運命シンカー占いプラットフォームへようこそ。ご利用前に以下の利用規約を必ずお読みください:
          </p>

          <h3>第一条 サービス内容と利用規則</h3>
          <ol>
            <li>
              <strong>娯楽目的の明示:</strong>
              本システムが提供する四柱推命、タロット、紫微斗数等の分析結果は
              <u>あくまで</u>
              娯楽目的の参考情報であり、専門的な助言や占い予測を構成するものではありません。
            </li>
            <li>
              <strong>意思決定リスクについて:</strong>
              ユーザーは本システムの分析結果を、医療・法律・投資・結婚等の重大な人生決定の根拠として
              <u>絶対に使用しないこと</u>
              を誓約します。本システムに基づくいかなる判断及びその結果について、当方は一切の責任を負いません。
            </li>
            <li>
              <strong>精度保証の免責:</strong>
              AI技術に基づく本システムは有益な情報提供を目的としますが、分析結果の正確性・完全性・適用性について
              <u>明示的に保証しないものとします</u>
              。ユーザーはこの点を十分理解した上でご利用ください。
            </li>
            <li>
              <strong>解釈の多様性:</strong>
              占い分析には様々な解釈方法と流派が存在します。本システムのアルゴリズムは特定の解釈視点に基づいており、ユーザーの未来を予測または保証するものではありません。
            </li>
          </ol>

          <h3>第二条 プライバシーとデータセキュリティ</h3>
          <ol>
            <li>
              <strong>プライバシー保護:</strong>
              ご提供いただいた生年月日情報はシステム内分析のみに使用されます。当方はプライバシー保護を重視しますが、第三者による不正な情報取得に対する法的責任は負いかねます。
            </li>
            <li>
              <strong>データ保存:</strong>
              収集した個人情報は暗号化された安全な環境で保管しますが、不可抗力による漏洩についての責任の範囲は法律の定めるところによるものとします。
            </li>
            <li>
              <strong>情報利用範囲:</strong>
              法令に基づく場合またはユーザーの明示的な同意がある場合を除き、個人情報を第三者に開示することはありません。
            </li>
          </ol>

          <h3>第三条 ユーザーの責任と義務</h3>
          <ol>
            <li>
              <strong>合法利用:</strong>
              中華人民共和国の関連法令を遵守し、本システムを不法または不適切な目的に使用しないものとします。
            </li>
            <li>
              <strong>情報の真実性:</strong>
              提供情報の正確性についてユーザー自身が責任を負い、不正確な情報による分析誤差については当方は責任を負いません。
            </li>
            <li>
              <strong>結果に対する理性的態度:</strong>
              システム生成コンテンツについては科学的・合理的な態度で接し、過度な依存または盲信を避けるものとします。
            </li>
          </ol>

          <h3>第四条 サービスの変更と終了</h3>
          <ol>
            <li>
              <strong>サービス調整:</strong>
              当方はシステムの改修・アップグレード・調整を行う権利を留保します。重大な変更については事前に通知しますが、緊急メンテナンス時には予告なく一時停止する場合があります。
            </li>
            <li>
              <strong>コンテンツ更新:</strong>
              アルゴリズムモデルと知識ベースは随時更新されるため、分析結果が変わる可能性があることをあらかじめご了承ください。
            </li>
            <li>
              <strong>規約変更:</strong>
              本利用規約は必要に応じて更新され、次回利用時に改めて確認いただきます。
            </li>
          </ol>

          <h3>第五条 免責事項と紛争解決</h3>
          <ol>
            <li>
              <strong>完全免責:</strong>
              本システムの利用により生じうる直接的・間接的損害（心理的傷害・判断ミス・経済損失・名誉毀損等を含む）について、当方は
              <u>明示的に一切の責任を負わないものとします</u>
            </li>
            <li>
              <strong>第三者リンク:</strong>
              本システムに含まれる外部サイトリンクについて、当方はその内容と行為について責任を負いません。
            </li>
            <li>
              <strong>紛争解決:</strong>
              本システム利用に関して疑問や紛争が生じた場合は、システム内のフィードバックチャネルからご連絡ください。誠意をもって対応いたします。
            </li>
          </ol>

          <h3>第六条 その他の規定</h3>
          <ol>
            <li>
              <strong>知的財産権:</strong>
              本システムの全てのコンテンツ（文章・画像・アルゴリズム・UIデザイン等）は知的財産法で保護されており、無断使用・複製・転載を禁じます。
            </li>
            <li>
              <strong>利用許諾範囲:</strong>
              ユーザーに付与されるのは個人非商業利用に限られる権利であり、リバースエンジニアリング・解析・商業利用等は固く禁じます。
            </li>
            <li>
              <strong>規約更新権:</strong>
              当方は随時本規約を変更できる権利を有し、変更後の規約はシステム内で公表されます。
            </li>
            <li>
              <strong>最終解釈権:</strong>
              本規約の最終解釈権は当システム開発者に帰属します。
            </li>
          </ol>

          <p class="disclaimer-emphasis">
            「同意して続行」をクリックすることで、貴方は本規約を全て読み、理解し、無条件で受け入れたことを確認したものとみなします。本システム提供コンテンツを理性的に扱うことを誓約します。いずれかの条項に同意できない場合は、直ちに利用を中止してください。
          </p>
        </div>
        <div class="agreement-actions">
          <button
            class="agree-btn"
            :style="
              agreementScrolled
                ? 'background-color: #CAA87C; color: #332F2C;'
                : 'background-color: #332F2C; color: #BEBEBE;'
            "
            @click="agreeToTerms"
          >
          {{ agreementScrolled ? "同意して続ける" : "内容を最後までお読みください" }}
          </button>
        </div>
      </div>
    </div>
    <div class="content-wrapper">
      <div class="login-box">
        <div class="login-header">
          <!-- <h1>運命シンカー</h1> -->
          <h1>運命シンカー</h1>
          <p>命理を解読し、未来を明かす</p>
        </div>

        <div class="login-form">
          <div class="form-item" style="background: transparent">
            <div
              style="
                display: flex;
                align-items: center;
                border: 1px solid rgb(202, 168, 124);
                border-radius: 4px;
                padding: 0px 15px;
                width: 100%;
              "
            >
              <div v-if="isMobileLogin" class="area-code-container">
                <div class="area-code-selector" @click.stop="toggleAreaCodeDropdown">
                  <span>{{ loginForm.areaCode }}</span>
                  <!-- <i class="el-icon-arrow-down"></i> -->
                </div>
                <div class="area-code-dropdown" v-show="showAreaCodeDropdown">
                  <div 
                    v-for="item in areaCodes" 
                    :key="item.id" 
                    class="area-code-item"
                    @click="selectAreaCode(item.areaCode)"
                  >
                    <span>{{ item.areaName }}</span>
                    <span>{{ item.areaCode }}</span>
                  </div>
                </div>
                <input
                  class="phone"
                  v-model="loginForm.phone"
                  @input="handleInput1"
                  placeholder="電話番号を入力"
                />
              </div>
              <input
                v-else
                class="email"
                v-model="loginForm.email"
                placeholder="メールアドレスをご入力ください"
              />
              <div
                style="
                  white-space: nowrap;
                  text-align: center;
                  disflay: flex;
                  flex: 1;
                "
              >
                <span
                  class="send-code-button"
                  :disabled="codeCountdown > 0"
                  @click="sendVerificationCode"
                >
                  {{ codeCountdown > 0 ? codeCountdown + "S" : "コードを取得" }}
                </span>
              </div>
            </div>
          </div>
          <div class="form-item">
            <el-input
              v-model="loginForm.code"
              type="number"
              placeholder="認証コードを入力してください"
              @input="handleInput"
            ></el-input>
          </div>
          <div
            class="form-item"
            style="color: #ffe8ca; text-align: right"
            @click="toggleLoginType"
          >
            {{
              isMobileLogin ? "メールアドレスでログイン" : "電話番号でログイン"
            }}
          </div>
          <div class="form-item">
            <el-button class="login-button" @click="handleLogin"
              >運命シンカー画面に移動</el-button
            >
          </div>
          <!-- <div class="form-label" @click="register">
            <span>没有账号？前往注册</span>
          </div> -->
        </div>
      </div>
    </div>
    <!-- <footer v-if="hideshow" class="disclaimer" style="">
      ICP:<span @click="goHome(9)">渝ICP备20009682号-2</span>
    </footer> -->
  </div>
</template>

<script>
import mixin from "@/mixins/comment";
import solarLunar from "solarlunar";
import {
  login,
  sendCode,
  recordPVUV,
  sendSmsCode,
  loginByPhone,
  getAreaCode
} from "@/api/index";

export default {
  mixins: [mixin],
  name: "mobile_login",
  data() {
    return {
      docmHeight:
        document.documentElement.clientHeight || document.body.clientHeight,
      showHeight:
        document.documentElement.clientHeight || document.body.clientHeight,
      hideshow: true, //显示或者隐藏footer
      agreementScrolled: false,
      isMobileLogin: false,
      loginForm: {
        username: "",
        password: "",
        phone: "",
        email: "",
        code: "",
        areaCode: "+81" // 默认日本区号
      },
      areaCodes: [], // 存储区号列表
      showAreaCodeDropdown: false, // 控制区号下拉框显示
      currentTime: "",
      lunarDate: "",
      timer: null,
      codeTimer: null,
      codeCountdown: 0,
      currentStep: "",
    };
  },
  // 监听页面高度
  watch: {
    //监听显示高度
    showHeight: function () {
      if (this.docmHeight > this.showHeight) {
        //隐藏
        this.hideshow = false;
      } else {
        //显示
        this.hideshow = true;
      }
    },
  },

  created() {
    this.updateTime();
    this.timer = setInterval(this.updateTime, 1000);

    // 只添加一次滚动监听
    this.$nextTick(() => {
      const maskTextElement = document.querySelector(".mask-text");
      if (maskTextElement) {
        maskTextElement.addEventListener("scroll", this.handleAgreementScroll);
      }
    });
  },
  mounted() {
    this.getCode();
    //监听事件
    window.onresize = () => {
      return (() => {
        this.showHeight =
          document.documentElement.clientHeight || document.body.clientHeight;
      })();
    };
    
    // 添加点击事件监听，用于关闭区号下拉框
    document.addEventListener('click', this.closeAreaCodeDropdown);
  },
  beforeDestroy() {
    // 移除滚动监听，避免内存泄漏
    const maskTextElement = document.querySelector(".mask-text");
    if (maskTextElement) {
      maskTextElement.removeEventListener("scroll", this.handleAgreementScroll);
    }
    if (this.timer) {
      clearInterval(this.timer);
    }
    
    // 移除点击事件监听
    document.removeEventListener('click', this.closeAreaCodeDropdown);
  },
  methods: {
    getCode(){
      getAreaCode().then(res => {
        if (res.code === 200 && res.data) {
          this.areaCodes = res.data;
        }
      })
    },
    
    // 选择区号
    selectAreaCode(areaCode) {
      this.loginForm.areaCode = areaCode;
      this.showAreaCodeDropdown = false;
    },
    
    // 切换区号下拉框显示状态
    toggleAreaCodeDropdown() {
      this.showAreaCodeDropdown = !this.showAreaCodeDropdown;
    },
    
    // 点击页面其他地方关闭区号下拉框
    closeAreaCodeDropdown() {
      this.showAreaCodeDropdown = false;
    },
    handleInput(e) {
      console.log(e, "e");
      this.loginForm.code = e.slice(0, 6);
      this.$forceUpdate();
    },
    handleInput1(e) {
      console.log(e.target.value, "e");
      const inputValue = e.target.value.replace(/\D/g, "");
      this.loginForm.phone = inputValue.slice(0, 11);
      this.$forceUpdate();
    },
    agreeToTerms() {
      if (this.agreementScrolled) {
        // 同意条款后的逻辑，比如跳转到首页
        this.$router.go(-1);
      } else {
        this.$message.warning("完全内容読");
      }
    },
    handleAgreementScroll(event) {
      console.log(event, "event");
      const element = event.target;
      // 检查是否滚动到底部（考虑一点误差）
      const isAtBottom =
        element.scrollHeight - element.scrollTop - element.clientHeight <= 5;
        if(isAtBottom){
          this.agreementScrolled = true
        }
      // this.agreementScrolled = isAtBottom;
    },
    backHome() {
      this.$router.push({ path: "/mobile_home" });
    },
    // 切换登录方式的方法
    toggleLoginType() {
      this.isMobileLogin = !this.isMobileLogin;
      this.loginForm.code = "";
      this.loginForm.phone = "";
      this.loginForm.email = "";
      clearInterval(this.codeTimer);
      this.codeTimer = null;
      this.codeCountdown = 0;
    },
    handleLogin() {
      if (this.isMobileLogin && !this.loginForm.phone) {
        this.$message.error("携帯電話番号入力");
        return;
      }
      if (this.isMobileLogin && !this.loginForm.areaCode) {
        this.$message.error("区号を選択してください");
        return;
      }
      if (!this.isMobileLogin && !this.loginForm.email) {
        this.$message.error("メールアドレス入力");
        return;
      }
      if (!this.loginForm.code) {
        this.$message.error("確認コード入力");
        return;
      }
      if (this.isMobileLogin) {
        // 构建带区号的手机号
        const phoneWithAreaCode = {
          ...this.loginForm,
          phone: this.loginForm.areaCode+ '-' + this.loginForm.phone
        };
        
        loginByPhone(phoneWithAreaCode)
          .then((response) => {
            console.log(response, "resooooooo");
            if (response.code === 200) {
              localStorage.setItem("ACCESS_TOKEN", response.data.auth);
              localStorage.setItem("userName", this.loginForm.phone);
              // this.$message.success("注册成功");
              this.currentStep = "agreement";
            } else {
              // this.$message.error(response.data.message);
            }
          })
          .catch((error) => {
            console.log(error);
            // this.$message.error(error.message || "登录失败");
          });
      } else {
        login(this.loginForm)
          .then((response) => {
            console.log(response, "resooooooo");
            if (response.code === 200) {
              localStorage.setItem("ACCESS_TOKEN", response.data.auth);
              localStorage.setItem("userName", this.loginForm.email);
              // this.$message.success("注册成功");
              this.currentStep = "agreement";
            } else {
              // this.$message.error(response.data.message);
            }
          })
          .catch((error) => {
            console.log(error);
            // this.$message.error(error.message || "登录失败");
          });
      }

      // 实际项目中这里会调用API进行登录验证
    },
    register() {
      this.$router.push({ path: "/mobile_register" });
    },
    getRandomStyle() {
      const size = Math.floor(Math.random() * 10) + 5;
      const posX = Math.random() * 100;
      const posY = Math.random() * 100;
      const animDuration = Math.random() * 20 + 10;
      const animDelay = Math.random() * 5;

      return {
        width: `${size}px`,
        height: `${size}px`,
        left: `${posX}%`,
        top: `${posY}%`,
        animationDuration: `${animDuration}s`,
        animationDelay: `${animDelay}s`,
      };
    },
    updateTime() {
      const now = new Date();
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");
      this.currentTime = `${hours}: ${minutes}: ${seconds}`;

      // 获取农历日期
      const solar = new Date();
      const lunarDate = solarLunar.solar2lunar(
        solar.getFullYear(),
        solar.getMonth() + 1,
        solar.getDate()
      );
      this.lunarDate = `${lunarDate.gzYear}年 ${lunarDate.gzMonth}月 ${lunarDate.gzDay}日`;
    },
    sendVerificationCode() {
      if (this.isMobileLogin && !this.loginForm.phone) {
        this.$message.error("携帯電話番号入力");
        return;
      }
      if (this.isMobileLogin && !this.loginForm.areaCode) {
        this.$message.error("区号を選択してください");
        return;
      }
      if (!this.isMobileLogin && !this.loginForm.email) {
        this.$message.error("メールアドレス入力");
        return;
      }
      if (this.codeCountdown > 0) return;
      if (this.isMobileLogin) {
        sendSmsCode({ phone: this.loginForm.areaCode+ '-' + this.loginForm.phone }).then((response) => {
          if (response.code === 200) {
            this.codeCountdown = 60;
            this.codeTimer = setInterval(() => {
              if (this.codeCountdown > 0) {
                this.codeCountdown--;
              } else {
                clearInterval(this.codeTimer);
                this.codeTimer = null;
              }
            }, 1000);
            this.$message.success("確認コード送");
          } else {
            console.log("2222");
            clearInterval(this.codeTimer);
            this.codeTimer = null;
            this.codeCountdown = 0;
            // this.$message.error(response.data.message || "发送失败");
          }
        });
      } else {
        sendCode({ email: this.loginForm.email }).then((response) => {
          if (response.code === 200) {
            this.codeCountdown = 60;
            this.codeTimer = setInterval(() => {
              if (this.codeCountdown > 0) {
                this.codeCountdown--;
              } else {
                clearInterval(this.codeTimer);
                this.codeTimer = null;
              }
            }, 1000);
            this.$message.success("確認コード送");
          } else {
            console.log("2222");
            clearInterval(this.codeTimer);
            this.codeTimer = null;
            this.codeCountdown = 0;
            // this.$message.error(response.data.message || "发送失败");
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.area-code-container {
  display: flex;
  align-items: center;
  width: 100%;
}

.area-code-selector {
  display: flex;
  align-items: center;
  /* padding: 0 5px; */
  cursor: pointer;
  color: #ffe8ca;
  border-right: 1px solid #CAA87C;
  margin-right: 5px;
  white-space: nowrap;
  width: 70px;
  text-align: center;
  justify-content: center;
}

.area-code-dropdown {
  position: absolute;
  top: 43%;
  left: 0;
  z-index: 10;
  background-color: #332F2C;
  border: 1px solid #CAA87C;
  border-radius: 4px;
  max-height: 200px;
  overflow-y: auto;
  width: 100%;
  margin-top: 5px;
}

.area-code-item {
  padding: 8px 15px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  color: #ffe8ca;
}

.area-code-item:hover {
  background-color: rgba(202, 168, 124, 0.1);
}

.login-container {
  height: 100%;
  width: 100%;
  flex: 1;
  position: relative;
  overflow: hidden;
  background-image: url("../../assets/mobile/dateBack.png");
  background-repeat: no-repeat;
  background-size: cover;
}

.content-wrapper {
  display: flex;
  justify-content: center;
  z-index: 1;
  max-width: 1200px;
  margin: 30% auto 0 auto;
  padding: 0 20px;
}
.nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* font-family: kunpeng; */
  font-weight: 400;
  font-size: 16px;
  color: #caa87c;
  padding: 0 20px;
  text-align: right;
  height: 56px;
}
.planet-section {
  text-align: center;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* gap: 3rem; */
  max-width: 360px;
}

.planet-orbit {
  width: 300px;
  height: 300px;
  opacity: 0.8;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* transform-style: preserve-3d; */
  /* perspective: 1000px; */
  /* transform: rotateX(20deg); */
}

.planet-text {
  /* margin-top: 30px; */
  color: #ffe8ca;
  text-align: center;

  h2 {
    font-size: 24px;
    font-weight: 400;
    font-family: Kunminghaiouti, Kunminghaiouti;
    margin-bottom: 10px;
    letter-spacing: 2px;
    animation: fadeInUp 0.8s ease-out forwards;
  }

  p {
    font-size: 16px;
    opacity: 0.8;
    font-family: Kunminghaiouti, Kunminghaiouti;
    animation: fadeInUp 0.8s ease-out forwards;
  }
}

.logo-container {
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 15px;
}

.logo-image {
  height: 32px;
  width: 32px;
  animation: rotate 30s linear infinite;
}
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

.circle-container {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.circle {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 0, 0, 0.05);
  box-shadow: 0 0 50px rgba(255, 0, 0, 0.1);
}

.circle-1 {
  width: 600px;
  height: 600px;
  top: -200px;
  right: -200px;
  background: rgba(255, 0, 0, 0.03);
  animation: float 20s infinite ease-in-out;
}

.circle-2 {
  width: 400px;
  height: 400px;
  bottom: -100px;
  left: -100px;
  background: rgba(255, 0, 0, 0.04);
  animation: float 15s infinite ease-in-out reverse;
}

.circle-3 {
  width: 300px;
  height: 300px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 0, 0, 0.02);
  animation: pulse 10s infinite ease-in-out;
}

.particles {
  position: absolute;
  width: 100%;
  height: 100%;
}

.particle {
  position: absolute;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  animation: float-particle 20s infinite linear;
}

.login-box {
  position: relative;
  z-index: 1;
  width: 400px;
}

.login-header {
  text-align: center;
  margin-bottom: 30px;

  h1 {
    color: #ffe8ca;
    font-size: 30px;
    margin-bottom: 10px;
    font-weight: 400;
    font-family: kunpeng;
    letter-spacing: 2px;
    text-shadow: 0 0 10px rgba(255, 255, 255, 0.3);
    animation: fadeInUp 0.8s ease-out forwards;
  }

  p {
    color: #ffe8ca;
    font-size: 25px;
    font-weight: 400;
    font-family: kunpeng;
    animation: fadeInUp 0.8s ease-out forwards;
  }
}

.login-form {
  .form-item {
    margin-bottom: 20px;
    background: transparent;
    border: none;
    padding: 0 20px;
  }

  .form-label {
    font-family: Source Han Serif SC, Source Han Serif SC;
    font-weight: 400;
    font-size: 16px;
    color: #ffe8ca;
    letter-spacing: 1px;
    text-align: center;
    cursor: pointer;
  }

  :deep(.el-input__inner) {
    background: transparent;
    border: 1px solid #caa87c;
    color: #fff;
    height: 50px;
    border-radius: 4px;
    font-family: Source Han Serif SC, Source Han Serif SC;
    font-weight: 400;
    font-size: 16px;
    color: #ffe8ca;
    position: relative;
    &::placeholder {
      color: rgba(255, 255, 255, 0.5);
    }
  }

  :deep(.el-input) {
    position: relative;
  }

  :deep(.el-input__prefix) {
    display: none;
  }

  .login-button {
    width: 100%;
    height: 44px;
    background: #caa87c;
    border: 1px solid #caa87c;
    font-family: Source Han Serif SC, Source Han Serif SC;
    font-weight: 400;
    font-size: 16px;
    color: #161b1a;
    letter-spacing: 2px;
    margin-top: 20px;
    border-radius: 22px;
    border-color: none;
    &:hover,
    &:focus {
      background: #d6b88c;
      box-shadow: 0 0 15px rgba(202, 168, 124, 0.5);
    }
  }
}
.email {
  background: transparent;
  border: none;
  height: 50px;
  font-family: Source Han Serif SC, Source Han Serif SC;
  font-weight: 400;
  font-size: 16px;
  color: #ffe8ca;
  outline: none;
  width: 80%;
  /* display: flex; */
  /* flex: 1; */
}
.phone {
  background: transparent;
  border: none;
  height: 50px;
  font-family: Source Han Serif SC, Source Han Serif SC;
  font-weight: 400;
  font-size: 16px;
  color: #ffe8ca;
  outline: none;
  width: 80%;
}
.send-code-button {
  height: 100%;
  font-family: Source Han Serif SC, Source Han Serif SC;
  font-weight: 400;
  font-size: 16px;
  color: #ffe8ca;
  margin-left: 10px;
  white-space: nowrap;
  width: 100%;
  text-align: right;
}
@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-30px);
  }
}

@keyframes pulse {
  0%,
  100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.5;
  }
  50% {
    transform: translate(-50%, -50%) scale(1.2);
    opacity: 0.3;
  }
}

@keyframes float-particle {
  0% {
    transform: translateY(0) rotate(0deg);
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    transform: translateY(-100vh) rotate(360deg);
    opacity: 0;
  }
}
@keyframes borderAnimation {
  0% {
    background-position: 0% 0%;
  }
  50% {
    background-position: 250% 0%;
  }
  100% {
    background-position: 500% 0%;
  }
}
.disclaimer {
  position: fixed;
  bottom: 16px;
  margin-top: 0;
  color: #ffffff4d;
  font-size: 12px;
  text-align: center;
  width: 100%;
}
.mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
}

.mask-content {
  width: 90%;
  height: 80%;
  margin: 0 auto;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 20px;
  color: #caa87c;
  overflow: hidden;
  border-radius: 10px;
}
.mask-content::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url("../../assets/dateBack.png");
  background-repeat: no-repeat;
  background-size: cover;
  z-index: -2;
}

.mask-content::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: -1;
}

.mask-title {
  font-size: 20px;
  text-align: center;
  margin-bottom: 20px;
  font-weight: bold;
  z-index: 1;
}

.mask-text {
  flex: 1;
  font-size: 14px;
  z-index: 1;
  overflow-y: auto;
  z-index: 1000;
  color: #ffffffe6;
  line-height: 1.6;
  position: relative;
}
.mask-text h3 {
  color: #deb887e6;
  border-bottom: 1px solid rgba(222, 184, 135, 0.3);
  padding-bottom: 0.5rem;
  /* font-family: var(--font-family-decorative); */
  letter-spacing: 1px;
  font-size: 15px;
  margin: 19px 10px;
}
.mask-text p {
  margin-bottom: 10px;
  z-index: 1;
}
.mask-text ol {
  padding-left: 24px;
  margin-bottom: 16px;
}
.agreement-actions {
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  z-index: 1;
}
.disclaimer-emphasis {
  color: #deb887e6;
  font-weight: 500;
  border-left: 3px solid rgba(222, 184, 135, 0.6);
  padding-left: 16px;
  margin-top: 24px;
}
.checkbox-container {
  display: flex;
  align-items: center;
  /* margin-bottom: 15px; */
  font-size: 12px;
  color: #caa87c;
}

.checkbox-container input {
  margin-right: 8px;
}

.agree-btn {
  border: none;
  padding: 10px 20px;
  border-radius: 20px;
  cursor: pointer;
  font-family: Source Han Serif SC, Source Han Serif SC;
  font-weight: 400;
  font-size: 12px;
  transition: all 0.3s ease;
  width: 136px;
}
</style>
